import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { InnerBlocks, RichText, useBlockProps } from "@wordpress/block-editor";
import "../slider/swiper";
import ImageEditor from "../../../source/components/ImageEditor";
import { useInnerBlocksProps } from "@wordpress/block-editor";

export default function IconCardEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "iconcard" });
  const isSelected = blockProps.className?.split(" ").includes("is-selected");

  const innerBlocksProps = useInnerBlocksProps({
    className: "iconcard-footer",
  });

  return (
    <div {...blockProps}>
      <ImageEditor
        attributes={props.attributes}
        setAttributes={props.setAttributes}
        prefix="image"
        placeholderClassName="img-placeholder"
      />
      <RichText
        value={props.attributes.title ?? ""}
        onChange={(title) => props.setAttributes({ title })}
        className="h4"
        placeholder="Überschrift…"
      />
      <div className="content">
        <RichText
          value={props.attributes.content ?? ""}
          onChange={(content) => props.setAttributes({ content })}
          className="content"
          placeholder="Inhalt"
        />
        <div {...innerBlocksProps} />
      </div>
    </div>
  );
}
